(function () {
  'use strict';
 
  document.addEventListener('DOMContentLoaded', init);
 
  function init() {
    (window.programmingKeysConfig || []).forEach(setupInstance);
  }
 
  // --- Shared details modal, fully self-contained with unique
  // class/attribute names so it cannot collide with the theme's own
  // modal system or any other script on the page (e.g. Ymq,
  // QuickCart) — same pattern as extended-warranty-addon's details
  // modal. Built once and reused for every instance of this widget on
  // the page. ---
  var modalEl = null;
  var modalImageEl = null;
  var modalTriggerEl = null; // element to restore focus to on close
 
  function getModal() {
    if (modalEl) return modalEl;
 
    modalEl = document.createElement('div');
    modalEl.className = 'programming-keys-details-modal';
    modalEl.setAttribute('data-programming-keys-details-modal', '');
 
    var backdrop = document.createElement('div');
    backdrop.className = 'programming-keys-details-modal__backdrop';
    backdrop.addEventListener('click', closeModal);
 
    var dialog = document.createElement('div');
    dialog.className = 'programming-keys-details-modal__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Programming key details');
 
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'programming-keys-details-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '\u00D7'; // ×
    closeBtn.addEventListener('click', closeModal);
 
    modalImageEl = document.createElement('img');
    modalImageEl.className = 'programming-keys-details-modal__image';
    modalImageEl.alt = 'Programming key details';
 
    dialog.appendChild(closeBtn);
    dialog.appendChild(modalImageEl);
    modalEl.appendChild(backdrop);
    modalEl.appendChild(dialog);
    document.body.appendChild(modalEl);
 
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl.classList.contains('programming-keys-details-modal--visible')) {
        closeModal();
      }
    });
 
    return modalEl;
  }
 
  function openModal(imageUrl, triggerEl) {
    var modal = getModal();
    modalImageEl.src = imageUrl;
    modal.classList.add('programming-keys-details-modal--visible');
    document.body.classList.add('programming-keys-details-modal-open');
    modalTriggerEl = triggerEl || null;
 
    var closeBtn = modal.querySelector('.programming-keys-details-modal__close');
    if (closeBtn) closeBtn.focus();
  }
 
  function closeModal() {
    if (!modalEl || !modalEl.classList.contains('programming-keys-details-modal--visible')) return;
    modalEl.classList.remove('programming-keys-details-modal--visible');
    document.body.classList.remove('programming-keys-details-modal-open');
    if (modalTriggerEl && typeof modalTriggerEl.focus === 'function') {
      modalTriggerEl.focus();
    }
    modalTriggerEl = null;
  }
  // --- End shared details modal ---
 
  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;
 
    if (!window.ProductAddonsCore) {
      console.error('programming-keys-selector: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }
 
    var chipGroup = root.querySelector('[data-programming-keys-chip-group]');
    var errorEl = root.querySelector('[data-programming-keys-error]');
    var detailsTrigger = root.querySelector('[data-programming-keys-details-trigger]');
    var detailsImageUrl = config.detailsImageUrl || '';
    var variants = config.variants || [];
    var selectedSkus = {}; // sku -> true, nothing selected by default
 
    if (detailsTrigger) {
      if (detailsImageUrl) {
        detailsTrigger.addEventListener('click', function () {
          openModal(detailsImageUrl, detailsTrigger);
        });
      } else {
        // No image configured — don't wire up a click that would open
        // an empty modal; fail loudly in the console instead.
        console.error('programming-keys-selector: detailsImageUrl is not set — check the details_image_url assign in programming-keys-selector.liquid');
      }
    }
 
    if (!variants.length) {
      showError('Programming key options are not configured correctly. Contact support.');
      console.error('programming-keys-selector: no variants resolved — check the addon product handle and its metafield/SKUs');
      // Register anyway so this fails loudly instead of silently
      // shipping without any programming key options at all.
      window.ProductAddonsCore.register(root, function () {
        showError('Programming key options are not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }
 
    renderChips();
    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);
 
    function renderChips() {
      chipGroup.innerHTML = '';
      variants.forEach(function (variant) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'product__chip';
        chip.dataset.sku = variant.sku;
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = chipLabel(variant);
        chip.addEventListener('click', function () {
          var isNowSelected = !selectedSkus[variant.sku];
          if (isNowSelected) {
            selectedSkus[variant.sku] = true;
          } else {
            delete selectedSkus[variant.sku];
          }
          chip.classList.toggle('selected', isNowSelected);
          chip.setAttribute('aria-pressed', isNowSelected ? 'true' : 'false');
          clearError();
          if (window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
        });
        chipGroup.appendChild(chip);
      });
    }
 
    // Live price preview only — no validation, no error UI.
    function getPriceContribution() {
      var total = 0;
      variants.forEach(function (v) {
        if (selectedSkus[v.sku]) total += Number(v.price);
      });
      return total;
    }
 
    function chipLabel(variant) {
      var name = (variant.label && variant.label !== 'Default Title') ? variant.label : variant.sku;
      return name + ' (+' + formatMoney(variant.price) + ')';
    }
 
    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    // Always ok: this option is entirely optional, zero selections is valid.
    function getContribution() {
      var items = variants
        .filter(function (v) { return selectedSkus[v.sku]; })
        .map(function (v) {
          return {
            id: v.variantId,
            quantity: 1,
            properties: { 'Programming Key': v.label || v.sku }
          };
        });
 
      clearError();
      return { ok: true, items: items };
    }
 
    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
  }
})();